var Item, _parseLinesAndNormalizeIndentation, beginSerialization, beginSerializeItem, deserializeItem, deserializeItemBody, deserializeItems, emptyEncodeLastItem, endSerialization, endSerializeItem, repeat, serializeItemBody;

repeat = require('../util').repeat;

Item = require('../item');


/*
Serialization
 */

beginSerialization = function(items, options, context) {
  return context.lines = [];
};

beginSerializeItem = function(item, options, context) {};

serializeItemBody = function(item, bodyAttributedString, options, context) {
  return context.lines.push(repeat('\t', item.depth - options.baseDepth) + bodyAttributedString.string);
};

endSerializeItem = function(item, options, context) {};

emptyEncodeLastItem = function(options, context) {
  return context.lines.push('');
};

endSerialization = function(options, context) {
  return context.lines.join('\n');
};


/*
Deserialization
 */

deserializeItemBody = function(item) {};

deserializeItem = function(text, outline) {
  var body, indent, item;
  item = outline.createItem();
  indent = text.match(/^\t*/)[0].length + 1;
  body = text.substring(indent - 1);
  item.indent = indent;
  item.bodyString = body;
  return item;
};

_parseLinesAndNormalizeIndentation = function(text) {
  var char, count, each, i, j, leadingSpacesRegex, len, length, lines, spacesPerTab;
  text = text.replace(/(\r\n|\n|\r)/gm, '\n');
  lines = text.split('\n');
  if (lines.length > 1) {
    spacesPerTab = Number.MAX_VALUE;
    for (j = 0, len = lines.length; j < len; j++) {
      each = lines[j];
      length = each.length;
      count = 0;
      i = 0;
      while (i < length) {
        char = each[i];
        if (char === ' ') {
          count++;
        } else if (char === '\t') {
          if (count > 0) {
            spacesPerTab = Math.min(spacesPerTab, count);
          }
          count = 0;
        } else {
          break;
        }
        i++;
      }
      if (count > 0) {
        spacesPerTab = Math.min(spacesPerTab, count);
      }
    }
    if (spacesPerTab !== Number.MAX_VALUE) {
      text = lines.join('\n');
      leadingSpacesRegex = new RegExp('^( {' + spacesPerTab + '})+', 'gm');
      text = text.replace(leadingSpacesRegex, function(matchText) {
        return Array(1 + (matchText.length / spacesPerTab)).join('\t');
      });
      text = text.replace(/^\s+/gm, function(matchText) {
        var index;
        index = matchText.indexOf(' ');
        if (index !== -1) {
          return matchText.substr(0, index);
        } else {
          return matchText;
        }
      });
      lines = text.split('\n');
    }
  }
  return lines;
};

deserializeItems = function(text, outline, options, deserializeItemCallback) {
  var eachEmpty, eachItem, eachLine, emptyLines, flatItems, j, k, l, len, len1, len2, lines, roots;
  if (options == null) {
    options = {};
  }
  if (deserializeItemCallback == null) {
    deserializeItemCallback = deserializeItem;
  }
  lines = _parseLinesAndNormalizeIndentation(text);
  flatItems = [];
  emptyLines = [];
  for (j = 0, len = lines.length; j < len; j++) {
    eachLine = lines[j];
    eachItem = deserializeItemCallback(eachLine, outline);
    flatItems.push(eachItem);
    if (/^\s*$/.test(eachLine)) {
      emptyLines.push(eachItem);
    } else {
      if (emptyLines.length) {
        for (k = 0, len1 = emptyLines.length; k < len1; k++) {
          eachEmpty = emptyLines[k];
          eachEmpty.indent = eachItem.indent;
        }
        emptyLines = [];
      }
    }
  }
  if (emptyLines.length) {
    for (l = 0, len2 = emptyLines.length; l < len2; l++) {
      eachEmpty = emptyLines[l];
      eachEmpty.indent = 1;
    }
  }
  roots = Item.buildItemHiearchy(flatItems);
  return roots;
};

module.exports = {
  beginSerialization: beginSerialization,
  beginSerializeItem: beginSerializeItem,
  serializeItemBody: serializeItemBody,
  endSerializeItem: endSerializeItem,
  endSerialization: endSerialization,
  emptyEncodeLastItem: emptyEncodeLastItem,
  deserializeItems: deserializeItems
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/serializations/text.js
 ** module id = 201
 ** module chunks = 0
 **/